// ナビゲーションのアクティブ状態管理
export function initNavigation() {
  console.log('Navigation: Initializing...');
  
  // ナビゲーションリンクとセクションを取得
  const navLinks = document.querySelectorAll('nav a[href^="#"]');
  const sections = document.querySelectorAll('section[id]');
  const sectionIDElement = document.getElementById('sectionID');
  
  if (navLinks.length === 0 || sections.length === 0) {
    console.warn('Navigation: No nav links or sections found');
    return;
  }
  
  // セクション名のマッピング
  const sectionNames = {
    'hero': 'Hero',
    'thought': 'Thought',
    'introduce': 'Introduce',
    'plans': 'Plans',
    'flow': 'Flow',
    'contact': 'Contact'
  };
  
  // アクティブリンクを更新する関数
  function updateActiveLink() {
    let currentSection = '';
    
    // 現在のスクロール位置を取得
    const scrollY = window.pageYOffset;
    
    // 各セクションの位置をチェック
    sections.forEach(section => {
      const sectionTop = section.offsetTop;
      const sectionHeight = section.offsetHeight;
      
      // セクションの中央点でアクティブを判定
      if (scrollY >= sectionTop - 200) {
        currentSection = section.getAttribute('id');
      }
    });
    
    // thoughtセクションの特別処理（slide01-07の範囲）
    const thoughtSection = document.querySelector('.thought');
    if (thoughtSection) {
      const thoughtTop = thoughtSection.offsetTop;
      const thoughtBottom = thoughtTop + thoughtSection.offsetHeight;
      
      if (scrollY >= thoughtTop - 200 && scrollY < thoughtBottom - 200) {
        currentSection = 'thought';
      }
    }
    
    // すべてのリンクからアクティブクラスを削除
    navLinks.forEach(link => {
      link.classList.remove('text-black');
      link.classList.add('text-[#aaa897]');
    });
    
    // 現在のセクションに対応するリンクをアクティブにする
    if (currentSection) {
      const activeLink = document.querySelector(`nav a[href="#${currentSection}"]`);
      if (activeLink) {
        activeLink.classList.remove('text-[#aaa897]');
        activeLink.classList.add('text-black');
      }
      
      // sectionID要素のテキストを更新（ふわっとしたアニメーション付き）
      if (sectionIDElement && sectionNames[currentSection]) {
        const newSectionName = sectionNames[currentSection];
        
        // 現在のテキストと異なる場合のみアニメーション実行
        if (sectionIDElement.textContent !== newSectionName) {
          // フェードアウト
          sectionIDElement.style.transition = 'opacity 0.3s ease-out';
          sectionIDElement.style.opacity = '0';
          
          // テキスト変更とフェードイン
          setTimeout(() => {
            sectionIDElement.textContent = newSectionName;
            sectionIDElement.style.opacity = '1';
          }, 300);
        }
      }
    }
  }
  
  // スクロールイベントリスナーを追加（throttle付き）
  let ticking = false;
  function onScroll() {
    if (!ticking) {
      requestAnimationFrame(() => {
        updateActiveLink();
        ticking = false;
      });
      ticking = true;
    }
  }
  
  // イベントリスナーを設定
  window.addEventListener('scroll', onScroll, { passive: true });
  
  // 初期状態を設定
  updateActiveLink();
  
  // スムーススクロールを追加
  navLinks.forEach(link => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      const targetId = link.getAttribute('href').substring(1);
      const targetSection = document.getElementById(targetId);
      
      if (targetSection) {
        // thoughtセクションの場合は最初のslideに移動
        if (targetId === 'thought') {
          const slide01 = document.getElementById('slide01');
          if (slide01) {
            slide01.scrollIntoView({ 
              behavior: 'smooth',
              block: 'start'
            });
            return;
          }
        }
        
        targetSection.scrollIntoView({ 
          behavior: 'smooth',
          block: 'start'
        });
      }
    });
  });
  
  console.log('Navigation: Initialized successfully');
}

// クリーンアップ関数
export function cleanupNavigation() {
  // 必要に応じてイベントリスナーを削除
  console.log('Navigation: Cleaned up');
}